(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eff-3d-gallery-hook"] && !Shopify.designMode) return;
  try {
    const prepareGalleryModels = (root = document) => {
    root.querySelectorAll('.eff-gallery-3d__model').forEach((viewer) => {
      if (viewer.dataset.galleryInteractionReady === 'true') return;
      viewer.dataset.galleryInteractionReady = 'true';
      ['pointerdown', 'pointermove', 'mousedown', 'mousemove', 'touchstart', 'touchmove'].forEach((eventName) => {
        viewer.addEventListener(eventName, (event) => event.stopPropagation(), { passive: true });
      });
    });
  };

  const updateVariantModels = (productId, variantId) => {
    document.querySelectorAll('[data-efforest-model-variant-ids]').forEach((element) => {
      if (element.dataset.efforestModelProductId !== String(productId)) return;

      let approvedVariantIds = [];
      try {
        approvedVariantIds = JSON.parse(element.dataset.efforestModelVariantIds || '[]').map(String);
      } catch (error) {
        approvedVariantIds = [];
      }

      const available = approvedVariantIds.length === 0 || approvedVariantIds.includes(String(variantId));
      element.dataset.efforestModelAvailable = String(available);
      if (element.dataset.efforestModelGateMode === 'hide') {
        element.hidden = !available;
      }
    });
  };

  const prepareVariantModelGates = (root = document) => {
    root.querySelectorAll('.eff-gallery-3d[data-efforest-model-product-id]').forEach((gallery) => {
      const productSection = gallery.closest('.product.section');
      if (!productSection || productSection.dataset.efforestModelVariantGateReady === 'true') return;
      productSection.dataset.efforestModelVariantGateReady = 'true';

      const productId = gallery.dataset.efforestModelProductId;
      const masterSelect = productSection.querySelector('[data-product-master-select]');
      if (masterSelect?.value) updateVariantModels(productId, masterSelect.value);

      productSection.addEventListener('variantChange', (event) => {
        if (event.detail?.variant?.id) updateVariantModels(productId, event.detail.variant.id);
      });
    });
  };

  prepareGalleryModels();
  prepareVariantModelGates();
  document.addEventListener('shopify:section:load', (event) => {
    prepareGalleryModels(event.target);
    prepareVariantModelGates(event.target);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gallery-full-3d]');
    if (!trigger) return;
    const viewer = document.querySelector('[data-efforest-3d]');
    if (!viewer) return;
    viewer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
